export const fixUserTypeEnums = (name) => {
  if (name === 'HomeOwner') {
    return 'Homeowner';
  }

  return name;
};
